import React, { useState, useMemo, useEffect } from "react"
import TopNavbar from "../../shares/TopNavbar"
import * as auth from '../../services/auth'
import * as api from '../../services/api'
import * as Account from '../../account';
import '../../index.css';
import Xarrow from "react-xarrows";
import flat from 'flat'
import { sortOnKeys, locale, formatDate } from "../../utils";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import ServiceStatus from "../../shares/ServiceStatus";

export default function Jobs(props) {

    const [selectedItems, setSelectedItems] = useState({
        customer: false,
        product: false,
        order: false,
    });

    const handleChange = (event) => {
        const { name, checked } = event.target;
        setSelectedItems(prevState => ({
            ...prevState,
            [name]: checked,
        }));
    };

    var account = Account.getUserAccount()
    const [errorMessage, setErrorMessage] = useState("");
    const [orderSelector, setOrderSelector] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedOrderType, setSelectedOrderType] = useState("0");
    const [order, setOrder] = useState([]);
    const [orderMessage, setOrderMessage] = useState("");

    const [QBOCompany, setQBOCompany] = useState(null);
    const [foraWorks, setForaWorks] = useState(false);
    const [foraCompany, setForaCompany] = useState(null);

    const [resyncOrder, setResyncOrder] = useState([]);
    
    const queryPlatform = new URLSearchParams(window.location.search).get("platform");
    const [selectedPlatform, setSelectedPlatform] = useState(
        ["quickbooks_online", "quickbooks_desktop", "csv"].includes(queryPlatform || "")
            ? queryPlatform
            : "quickbooks_online"
    );

    useEffect(() => {
        if (selectedPlatform == "csv")
            window.location.href = "/jobs/csv"
        if (selectedPlatform == "quickbooks_desktop")
            window.location.href = "/jobs/desktop"

    }, [selectedPlatform])

    const checkForaWorks = () => {
        api.getHealth()
            .then(response => {
                setForaWorks(response.success)
                if (response.model)
                    setForaCompany(response.model)
            })
            .catch(err => {
                setForaWorks(false)
            }).finally(_ => {

            })
    }

    const checkQBWorks = () => {
        api.quickBooksCompanyInfo()
            .then(response => {
                setQBOCompany(response)
            })
            .catch(err => {
                if (err && err.data && err.data.error)
                    setErrorMessage(err.data.error)
                console.log(err)
            }).finally(_ => {

            })
    }


    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingLog, setLoadingLog] = useState(false);
    let timerId;
    const runJob = () => {

        const options = Object.keys(selectedItems).filter((key) => selectedItems[key])
        if (options.length == 0) return

        setLoading(true)

        var data = {
            Options: options,
            ResyncOrder: resyncOrder,
            ResyncOrderID: "",
            ResyncOrderKey: "",
            CompanyName: account && account.user && account.user.Name
        }

        api.sync(data)
            .then(res => {
                //console.log(res)
            })
            .catch(err => {
                if (err && err.data && err.data.error)
                    setErrorMessage(err.data.error)
                console.log(err)
            }).finally(_ => {
                setResyncOrder([]);
                options.forEach(function (job) {
                    setSelectedItems(prevState => ({
                        ...prevState,
                        [job]: false,
                    }));
                })
                setLoading(false)
                setLoadingLog(true)
                timerId = setTimeout(logs, 5000);
            })

    }


    const logs = () => {
        var data = {
            platform: "quickbooks_online",
        }
        setLoadingLog(true)
        api.logs(data)
            .then(response => {
                setData(response)
            })
            .catch(err => {
                if (err && err.data && err.data.error)
                    setErrorMessage(err.data.error)
                console.log(err)
            }).finally(_ => {
                setLoadingLog(false)
            })
    }

    const deleteLog = (id) => {
        if (!window.confirm('Are you sure you want to delete?')) 
            return
        api.deleteLog(id).finally(() => logs())
    };

    const handleTabClose = event => {
        event.preventDefault();
        return (event.returnValue = 'Are you sure you want to exit?');
    };


    useEffect(() => {
        //const interval = setInterval(logs, 10000);
        logs()
        checkForaWorks()
        checkQBWorks()

        window.addEventListener('beforeunload', handleTabClose);
        return () => {
            window.removeEventListener('beforeunload', handleTabClose);
        };
    }, [])

    const fetchOrder = () => {
        setLoading(true)
        setOrderMessage("")
        api.foraOrdersOrQuotes(selectedOrderType, selectedDate ? format(selectedDate, 'yyyy-MM-dd') : "")
            .then(response => {

                if (response && response.message)
                    setOrderMessage(response.message)

                if (response && response.model)
                    setOrder(response.model)
            })
            .catch(err => {
                if (err && err.data && err.data.error)
                    setErrorMessage(err.data.error)
                console.log(err)
            }).finally(_ => {
                setLoading(false)
            })

    }

    const parseStatus = (item) => {
        var data = JSON.parse(item)

        if (!data) return "FAILED";

        var result = data.result

        if (!result) return "FAILED"

        if (result.order)
            return result.order.error_message ? "FAILED" : data.status

        if (data.job == "order" && (!result.synced || result.synced.length == 0)) return "FAILED";

        if (result.synced && Array.isArray(result.synced))
            return result.synced.map(t => t.Error ? "FAILED" : data.status).join(',').split(",")[0]


        return data.status

    }

    const canResync = (item) => {
        var data = JSON.parse(item)

        if (!data) return false

        var result = data.result

        if (!result) return false

        if (result.order) {
            return result.order.Key && result.order.SaleOrderNumber
        }

    }

    const resync = (item) => {
        var data = JSON.parse(item)

        if (!data) return;

        var result = data.result

        if (!result) return;

        if (result.order) {
            if (result.order.Key && result.order.SaleOrderNumber) {
                if (!resyncOrder.some(obj => obj.SaleOrderNumber === result.order.SaleOrderNumber))
                    setResyncOrder([...resyncOrder, { Key: result.order.Key, SaleOrderNumber: result.order.SaleOrderNumber }])

                // window.scrollTo({
                //     top: 0,
                //     behavior: 'smooth'
                // });
            }
        }
    }

    const selectOrder = (SaleOrderNumber, Key) => {
        if (!resyncOrder.some(obj => obj.SaleOrderNumber === SaleOrderNumber))
            setResyncOrder([...resyncOrder, { Key: Key, SaleOrderNumber: SaleOrderNumber }])
    }


    const removeObject = (SaleOrderNumber) => {
        setResyncOrder(resyncOrder.filter((c) => c.SaleOrderNumber !== SaleOrderNumber));
    };

    useEffect(() => {

        var doing = false
        if (resyncOrder.length > 0)
            doing = true

        setSelectedItems({
            customer: false,
            product: false,
            order: doing,
        });

    }, [resyncOrder])

    const parseResult = (item) => {
        var data = JSON.parse(item)

        if (!data) return "";

        var result = data.result

        if (!result) return `No new ${data.job}s to sync`;

        if (result.order)
            return result.order.Order + (result.order.error_message ? " import failed. "
                : ` imported successfully to ${result.order.Company && result.order.Company.Name ? result.order.Company.Name + " - " : ""} ${result.order.Customer && result.order.Customer.Name ? result.order.Customer.Name + "'s" : ""} ${result.order.RefNumber}.`)
                + (result.order.Notfound && result.order.Notfound?.length > 0 ? `\nThe following products were not found in QuickBooks:\n${result.order.Notfound.join("\n")}` : result.order.error_message ? result.order.error_message : "")

        if (result.synced && Array.isArray(result.synced))
            return result.synced.map(t => "Fora " + (t.ForaOrder || t.Quote || t.Order)
                + (t.QBOrder ? " successfully import to\nQuickBooks Online. QuickBooks " + t.QBOrder.DocNumber : (t.Error ? " failed to import to QuickBooks Online" : ""))
                + (t.Notfound && t.Notfound?.length > 0 ? `\nThe following products were not found in QuickBooks:\n${t.Notfound.join("\n")}` : t.error_message ? t.error_message : "")
            ).join('\n\n')


        if (result.fora_response) {
            try {
                return JSON.parse(result.fora_response).Message
            } catch {
                return result.fora_response
            }
        }

        return result.error_message
    }

    return (
        <>
            <div id="error-message" className={`fixed top-0 left-0 right-0 bg-yellow-100 border-t-4 border-yellow-500 p-4 z-50 ${errorMessage ? "" : "hidden"}`}>
                <div className="flex justify-between items-center">
                    <div>
                        <p className="text-yellow-700 font-bold">Notice !</p>
                        <p className="text-yellow-600">{errorMessage}</p>
                    </div>
                    <button id="close-error" className="text-red-600 hover:text-yellow-800" onClick={e => { setErrorMessage(""); }}>
                        <svg className="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M14.293 5.293a1 1 0 011.414 1.414L11.414 11l4.293 4.293a1 1 0 11-1.414 1.414L10 12.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 11 4.293 6.707a1 1 0 111.414-1.414L10 9.586l4.293-4.293z" /></svg>
                    </button>
                </div>
            </div>
            <div className="min-h-full">
                <ServiceStatus
                    platform={selectedPlatform}
                    foraWorks={foraWorks}
                    foraCompany={foraCompany}
                    account={account}
                    QBOCompany={QBOCompany}
                />
                <TopNavbar />
                <header className="bg-white shadow">
                    <div className="mx-auto max-w-4xl py-6 px-4 sm:px-6 lg:px-8">
                        <div className="relative min-h-[40px]">
                            <a href="/mapping?platform=quickbooks_online" className="absolute left-0 top-0 text-gray-500 font-bold p-1 m-2 whitespace-nowrap">
                                <span className="mr-2 text-xl">&larr;</span>Mapping
                            </a>
                            <h1 className="px-28 text-center text-xl font-bold tracking-tight text-gray-900">QuickBooks Online Synchronization</h1>
                            <a href="/logs?platform=quickbooks_online" className="absolute right-0 top-0 text-gray-500 font-bold p-1 m-2 whitespace-nowrap">
                                Logs<span className="ml-2 text-xl">&rarr;</span>
                            </a>
                        </div>
                    </div>
                </header>
                <main className="container mx-auto px-4 w-full items-center justify-center">
                    <div className="min-h-screen">
                        <div className="max-w-4xl mx-auto py-4">
                            <div className="space-y-6 w-full">
                                <div className="bg-white shadow-lg rounded-lg px-6 py-4 flex items-center justify-between">
                                    <div className="w-full">
                                        <div className="justify-between items-center flex mt-2">
                                            <div className="flex flex-col">
                                                <div className="items-center">
                                                    <input type="checkbox"
                                                        id="cbx_customer"
                                                        name="customer"
                                                        checked={selectedItems.customer}
                                                        onChange={handleChange}
                                                        className="mr-3"
                                                    />
                                                    <label htmlFor="cbx_customer" className="font-bold cursor-pointer">Customers <span className="ml-2 font-light text-md">from <span className="font-bold">QuickBooks Online</span> to <span className="font-bold">Fora Mobile Commerce Platform</span></span></label>

                                                    <span className="flex text-md text-yellow-500 items-center">
                                                        <svg className="mr-2 w-4 h-4 text-yellow-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                                                        </svg>
                                                        <p>Only customers with Status = "Active" will be Synced</p>
                                                        {/* <p>Only customers with Status = "Active" and Custom Field - Fora = "Yes" will be Synced</p> */}
                                                    </span>
                                                </div>
                                                <div className="items-center mt-4">
                                                    <input type="checkbox"
                                                        id="cbx_product"
                                                        name="product"
                                                        checked={selectedItems.product}
                                                        onChange={handleChange}
                                                        className="mr-3"
                                                    />
                                                    <label htmlFor="cbx_product" className="font-bold cursor-pointer">Products<span className="ml-2 font-light text-md">from <span className="font-bold">QuickBooks Online</span> to <span className="font-bold">Fora Mobile Commerce Platform</span></span></label>
                                                    <span className="flex text-md text-yellow-500 items-center">
                                                        <svg className="mr-2 w-4 h-4 text-yellow-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                                                        </svg>
                                                        <p>Only Inventory and Non-inventory items with Status = "Active" will be Synced</p>
                                                    </span>
                                                </div>
                                                {resyncOrder.length > 0 ?
                                                    <div className="mt-4 flex items-center">
                                                        <input type="checkbox"
                                                            id="cbx_order"
                                                            name="order"
                                                            checked={selectedItems.order}
                                                            onChange={handleChange}
                                                            className="mr-3"
                                                        />
                                                        <label htmlFor="cbx_order" className="font-bold cursor-pointer">Sync Orders</label>
                                                    </div> :
                                                    <div className="justify-end mt-4">
                                                        <input type="checkbox"
                                                            id="cbx_order"
                                                            name="order"
                                                            checked={selectedItems.order}
                                                            onChange={handleChange}
                                                            className="mr-3"
                                                        />
                                                        <label htmlFor="cbx_order" className="font-bold cursor-pointer">New Orders
                                                            <span className="ml-2 font-light text-md">from <span className="font-bold">Fora Mobile Commerce Platform</span> to <span className="font-bold">QuickBooks Online</span></span>
                                                        </label>

                                                    </div>}

                                                <div className="justify-end ml-6">
                                                    <button className="text-md font-medium cursor-pointer underline decoration-dotted text-blue-600 underline-offset-4" onClick={_ => setOrderSelector(!orderSelector)}>Or click here to select Orders</button>
                                                </div>

                                                <div className="grid grid-cols-3 gap-2 mt-2">
                                                    {resyncOrder.map((c, i) => {
                                                        return <div key={`resync-${i}`} className="flex items-center">
                                                            <p className="ml-2 font-bold text-md text-blue-600">{locale(c.Key) + "#" + c.SaleOrderNumber}</p>
                                                            <button onClick={e => { removeObject(c.SaleOrderNumber); }} className={`text-md ml-2 bg-gray-50 hover:bg-gray-100 text-red-500 border-2 border-red-500 p-1 rounded focus:outline-none focus:shadow-outline`}>Remove</button>
                                                        </div>
                                                    })}
                                                </div>
                                            </div>

                                            <div className="">
                                                <button onClick={e => { if (!loading) runJob() }} className={`w-36 flex items-center justify-center bg-gray-50 hover:bg-gray-100 border-2 border-gray-500 text-gray-500 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline`}>
                                                    {loading ?
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 animated-spin">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                                                        </svg>
                                                        : "Sync"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {orderSelector ?
                                    <div className="relative bg-blue-100 shadow-lg rounded-lg px-6 py-4 items-center justify-between">
                                        <button className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-3xl" aria-label="Close" onClick={e => setOrderSelector(false)}>&times;</button>
                                        <div className="w-full flex items-center">
                                            <h2 className="font-bold text-gray-900 p-2">Select</h2>
                                            {/* */}
                                            <select value={selectedOrderType} onChange={e => { setSelectedOrderType(e.target.value); setOrder([]) }} className="appearance-none bg-white border-2 border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline" >
                                                <option value="0">Order</option>
                                                <option value="1">Quote</option>
                                            </select>
                                            <h2 className="font-bold text-gray-900 p-2">At</h2>
                                            <DatePicker
                                                className="w-full appearance-none bg-white border-2 border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded  leading-tight focus:outline-none focus:shadow-outline"
                                                selected={selectedDate}
                                                onChange={date => setSelectedDate(date)}
                                                dateFormat="yyyy-MM-dd"
                                                placeholderText="Select a date"
                                            />
                                            <button onClick={e => { setLoading(true); timerId = setTimeout(fetchOrder, 1); }} className={`ml-4 flex items-center justify-center ${!loading && foraWorks ? "bg-gray-50 hover:bg-gray-100 border-2 border-gray-500" : "bg-gray-300 disable"} font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline`}>
                                                {loading ?
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 animated-spin">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                                                    </svg>
                                                    : "Show"}
                                            </button>
                                            {orderMessage ? <p className="ml-4 text-md font-medium">{orderMessage}</p> : null}
                                        </div>
                                        {order && order.length > 0 ?
                                            <div className="mt-4 overflow-x-auto">
                                                <table className="divide-y divide-gray-200 table-fixed w-full">
                                                    <thead className="bg-gray-50">
                                                        <tr>
                                                            <th scope="col" className="w-2/6 px-6 py-3 text-center text-md font-medium text-gray-500">

                                                            </th>
                                                            <th scope="col" className="w-3/6 px-6 py-3 text-left text-md font-medium text-gray-500">
                                                                Detail
                                                            </th>
                                                            <th scope="col" className="w-1/6 px-6 py-3 text-left text-md font-medium text-gray-500">
                                                                At
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="bg-white divide-y divide-gray-200">

                                                        {order && order.map((k, i) => (
                                                            <tr key={k.saleOrderNumber}>

                                                                <td className="p-3 flex justify-start items-center">
                                                                    <input type="checkbox"
                                                                        id={`cbx_order-${k.saleOrderNumber}`}
                                                                        checked={resyncOrder.some(obj => obj.SaleOrderNumber === k.saleOrderNumber)}
                                                                        onChange={e => {
                                                                            if (e.target.checked) {
                                                                                selectOrder(k.saleOrderNumber, selectedOrderType == "0" ? "orders" : "quotes")
                                                                            } else {
                                                                                removeObject(k.saleOrderNumber)
                                                                            }
                                                                        }}
                                                                    ></input>
                                                                    <label htmlFor={`cbx_order-${k.saleOrderNumber}`} className="flex justify-start items-center cursor-pointer">

                                                                        <p className="ml-4 items-center font-medium">{i + 1}.</p>
                                                                        <div className="ml-2 text-sm text-gray-900 text-left">
                                                                            {(selectedOrderType == "0" ? "Order" : "Quote")}#{k.saleOrderNumber}

                                                                        </div>
                                                                    </label>

                                                                </td>
                                                                <td className="p-3 whitespace-nowrap">

                                                                    <p className="ml-2 text-gray-900 truncate whitespace-pre-line text-md underline decoration-dotted ">{(k.promotionTitle)}</p>
                                                                    <p className="ml-2 text-gray-900 truncate whitespace-pre-line text-sm">{(k.customer.customerName)}</p>
                                                                </td>
                                                                <td className="p-2 whitespace-pre-line">
                                                                    <div className="text-md text-gray-900">{formatDate(k.createDate)}</div>
                                                                </td>
                                                            </tr>
                                                        ))}

                                                    </tbody>
                                                </table>

                                            </div> : null}
                                    </div>

                                    : null}
                                <div className="bg-white shadow-lg rounded-lg px-6 py-4 items-center justify-between">
                                    <div className="w-full flex">
                                        <h2 className="font-bold text-gray-900 p-2">Latest Jobs</h2>

                                        <button onClick={e => { setLoadingLog(true); timerId = setTimeout(logs, 1000); }} className={`font-bold p-2`}>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={`w-4 h-4 ${loadingLog ? "animated-spin" : ""}`}>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                                            </svg>
                                        </button>
                                    </div>
                                    <div className="mt-4 overflow-x-auto">
                                        <table className="divide-y divide-gray-200 table-fixed w-full">
                                            <thead className="bg-gray-50">
                                                <tr>

                                                    <th scope="col" className="w-1/6 px-6 py-3 text-left text-md font-medium text-gray-500">
                                                        Job
                                                    </th>
                                                    <th scope="col" className="w-4/6 px-6 py-3 text-left text-md font-medium text-gray-500">
                                                        Result
                                                    </th>
                                                    <th scope="col" className="w-1/6 px-6 py-3 text-left text-md font-medium text-gray-500">
                                                        At
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">

                                                {data && data.map((k) => (
                                                    <tr key={k.id}>
                                                        {/* <td className="px-6 py-4">
                                                        <div className="text-md text-gray-900">
                                                            {locale(JSON.parse(k.data).platform)}
                                                        </div>
                                                    </td> */}
                                                        <td className="p-3">
                                                            <div className="text-sm text-gray-900">
                                                                {locale(JSON.parse(k.data).job)}
                                                                {
                                                                    canResync(k.data) && JSON.parse(k.data).job == "order" ?
                                                                        <button onClick={e => { resync(k.data) }} className={`text-md ml-2 bg-gray-50 hover:bg-gray-100 border-2 border-gray-500 text-gray-500 p-1 rounded focus:outline-none focus:shadow-outline font-bold`}>Re-sync</button>
                                                                        : null
                                                                }
                                                            </div>
                                                        </td>
                                                        <td className="p-3 whitespace-nowrap">
                                                            <span className={`items-start text-md ${parseStatus(k.data) == "OK" ? "text-green-600" : "text-red-600"} flex`}>{parseStatus(k.data)}<p className="ml-2 text-gray-900 truncate whitespace-pre-line">{parseResult(k.data)}</p></span>
                                                        </td>
                                                        <td className="p-2 whitespace-pre-line">
                                                            <div className="text-xs text-gray-900 flex">{formatDate(k.createdAt)}
                                                                <button onClick={e => {deleteLog(k.id)}} className={`ml-2 text-xs text-red-500`}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4">
                                                                        <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}

                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div >
        </>

    )
}

